export class CartService {
  constructor(repository) {
    this._repository = repository
  }

  getCartByOrderReference(orderReference) {
    return this._repository.getCartByOrderReference(orderReference)
  }
}
